import { render, staticRenderFns } from "./CountrySVG.vue?vue&type=template&id=eba89532&scoped=true"
import script from "./CountrySVG.vue?vue&type=script&lang=js"
export * from "./CountrySVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba89532",
  null
  
)

export default component.exports